import { render } from "./DisinfectRoom.vue?vue&type=template&id=12ee9cd8"
import script from "./DisinfectRoom.vue?vue&type=script&lang=js"
export * from "./DisinfectRoom.vue?vue&type=script&lang=js"
script.render = render

export default script